import { useEffect, useRef } from "preact/hooks";

export const OnClickOutside = ({
    onClickOutside,
    children,
}: {
    onClickOutside: (e: MouseEvent) => void;
    children: preact.VNode;
}) => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handler = (e: MouseEvent) => {
            const el = ref.current;
            if (!el) return;

            const target = e.target as Node;
            if (!el.contains(target)) {
                onClickOutside(e);
            }
        };

        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, [onClickOutside]);

    return <div ref={ref}>{children}</div>;
};
